<template>
  <section class="workspace-stack">
    <article class="glass-surface workspace-panel">
      <div class="workspace-panel__header">
        <div>
          <span class="workspace-kicker">Revision y monetizacion</span>
          <h2 class="workspace-title">Configuracion por evento</h2>
          <p class="workspace-copy">Aprueba eventos pendientes, define su salida final y ajusta fees y medios desde un solo lugar.</p>
        </div>
      </div>

      <div class="workspace-metrics">
        <article class="workspace-metric">
          <small>Eventos</small>
          <strong>{{ filteredEvents.length }}</strong>
        </article>
        <article class="workspace-metric">
          <small>En revision</small>
          <strong>{{ pendingReviewCount }}</strong>
        </article>
        <article class="workspace-metric">
          <small>Opciones activas</small>
          <strong>{{ activeOptionCount }}</strong>
        </article>
      </div>

      <div class="workspace-toolbar">
        <label class="workspace-search">
          <i class="fas fa-search"></i>
          <input v-model="search" type="text" placeholder="Buscar por evento, slug o host" />
        </label>
        <select v-model="reviewFilter" class="workspace-input workspace-select fee-toolbar__filter">
          <option value="all">Todos los estados</option>
          <option value="pending">Pendientes</option>
          <option value="approved">Aprobados</option>
          <option value="rejected">Rechazados</option>
        </select>
      </div>

      <div v-if="loading" class="workspace-empty">Cargando configuraciones...</div>
      <div v-else-if="!filteredEvents.length" class="workspace-empty">No hay eventos para configurar.</div>

      <div v-else class="fee-config-stack">
        <article v-for="event in filteredEvents" :key="event.id" class="fee-event-card">
          <div class="fee-event-card__top">
            <div>
              <span class="workspace-kicker">{{ event.slug || 'sin-slug' }}</span>
              <h3>{{ event.name }}</h3>
              <p>{{ event.host_name }} - {{ formatDate(event.start_date) }}</p>
            </div>
            <div class="fee-event-card__actions">
              <span class="workspace-status-pill" :class="reviewClass(event.review_status)">
                {{ reviewLabel(event.review_status) }}
              </span>
              <span class="workspace-status-pill" :class="activeSettings(event) ? 'is-active' : 'is-warning'">
                {{ activeSettings(event) ? activeSettings(event) + ' activas' : 'Sin medios activos' }}
              </span>
              <button class="workspace-button workspace-button--ghost workspace-button--small" type="button" @click="event.expanded = !event.expanded">
                <span>{{ event.expanded ? 'Cerrar' : 'Editar' }}</span>
              </button>
            </div>
          </div>

          <div v-if="event.expanded" class="fee-event-card__body">
            <div class="fee-defaults-grid">
              <label class="workspace-field">
                <span>Estado de revision</span>
                <select v-model="event.review_status" class="workspace-input workspace-select">
                  <option value="pending">Pendiente</option>
                  <option value="approved">Aprobado</option>
                  <option value="rejected">Rechazado</option>
                </select>
              </label>
              <label class="workspace-field">
                <span>Salida final</span>
                <select v-model.number="event.type" class="workspace-input workspace-select">
                  <option :value="1">Publico</option>
                  <option :value="2">Privado</option>
                  <option :value="3">No publicar aun</option>
                </select>
              </label>
              <label class="workspace-field">
                <span>Quien asume el fee</span>
                <select v-model.number="event.fee_bearer" class="workspace-input workspace-select">
                  <option :value="1">Cliente asume fees</option>
                  <option :value="2">Organizador asume fees</option>
                </select>
              </label>
              <label class="workspace-field">
                <span>Fallback %</span>
                <input v-model="event.coordinated_fee" class="workspace-input" type="number" min="0" step="0.0001" />
              </label>
              <label class="workspace-field">
                <span>Fallback fijo</span>
                <input v-model="event.fixed_fee" class="workspace-input" type="number" min="0" step="0.0001" />
              </label>
              <label class="workspace-field">
                <span>Fallback por ticket</span>
                <input v-model="event.coordinated_service" class="workspace-input" type="number" min="0" step="0.0001" />
              </label>
            </div>

            <p class="fee-event-card__review-note">
              <strong>Salida elegida:</strong> {{ typeLabel(event.type) }}.
              <span v-if="event.review_status === 'approved'"> Al guardar en aprobado, se envia el mail al organizador.</span>
            </p>

            <div class="fee-option-grid">
              <article v-for="setting in event.payment_option_settings" :key="setting.payment_option_id" class="fee-option-card">
                <div class="fee-option-card__head">
                  <label class="fee-option-card__toggle">
                    <input v-model="setting.enabled" type="checkbox" />
                    <span>{{ setting.name || ('Opcion ' + setting.payment_option_id) }}</span>
                  </label>
                  <small>{{ pricingSourceLabel(setting.pricing_source) }}</small>
                </div>

                <div class="fee-option-card__grid">
                  <label class="workspace-field">
                    <span>Nombre visible</span>
                    <input v-model="setting.label_override" class="workspace-input" type="text" placeholder="Opcional" />
                  </label>
                  <label class="workspace-field">
                    <span>Modo fee</span>
                    <select v-model="setting.platform_fee_mode" class="workspace-input workspace-select">
                      <option value="standard">Estandar</option>
                      <option value="custom_formula">Personalizado</option>
                      <option value="custom_fixed">Monto fijo</option>
                    </select>
                  </label>
                  <label v-if="setting.platform_fee_mode === 'custom_formula'" class="workspace-field">
                    <span>Fee %</span>
                    <input v-model="setting.platform_fee_percent" class="workspace-input" type="number" min="0" step="0.0001" placeholder="fallback" />
                  </label>
                  <label v-if="setting.platform_fee_mode === 'custom_formula'" class="workspace-field">
                    <span>Fee fijo</span>
                    <input v-model="setting.platform_fee_fixed" class="workspace-input" type="number" min="0" step="0.0001" placeholder="fallback" />
                  </label>
                  <label v-if="setting.platform_fee_mode === 'custom_formula'" class="workspace-field">
                    <span>Fee ticket</span>
                    <input v-model="setting.platform_fee_per_ticket" class="workspace-input" type="number" min="0" step="0.0001" placeholder="fallback" />
                  </label>
                  <label v-if="setting.platform_fee_mode === 'custom_fixed'" class="workspace-field">
                    <span>Monto fijo final</span>
                    <input v-model="setting.platform_fee_fixed" class="workspace-input" type="number" min="0" step="0.0001" placeholder="1.0000" />
                  </label>
                  <label class="workspace-field">
                    <span>Proc %</span>
                    <input v-model="setting.processor_fee_percent" class="workspace-input" type="number" min="0" step="0.0001" placeholder="auto" />
                  </label>
                  <label class="workspace-field">
                    <span>Proc fijo</span>
                    <input v-model="setting.processor_fee_fixed" class="workspace-input" type="number" min="0" step="0.0001" placeholder="auto" />
                  </label>
                  <label class="workspace-field">
                    <span>Extra %</span>
                    <input v-model="setting.processor_fee_extra_percent" class="workspace-input" type="number" min="0" step="0.0001" placeholder="auto" />
                  </label>
                  <label class="workspace-field">
                    <span>Extra tax %</span>
                    <input v-model="setting.processor_fee_extra_tax_percent" class="workspace-input" type="number" min="0" step="0.0001" placeholder="auto" />
                  </label>
                  <label class="workspace-field">
                    <span>Moneda</span>
                    <input v-model="setting.currency" class="workspace-input" type="text" placeholder="USD / AR" />
                  </label>
                </div>

                <p class="fee-option-card__note">{{ feeModeCopy(setting) }}</p>

                <div class="fee-option-card__effective">
                  <span>Fee aplicado: {{ feeModeLabel(setting.effective_profile.platform_fee_mode) }} - {{ setting.effective_profile.platform_fee_percent }} / {{ setting.effective_profile.platform_fee_fixed }} / {{ setting.effective_profile.platform_fee_per_ticket }}</span>
                  <span>Procesador: {{ setting.effective_profile.processor_fee_percent }} / {{ setting.effective_profile.processor_fee_fixed }}</span>
                </div>
              </article>
            </div>

            <div class="workspace-actions workspace-actions--end">
              <button v-if="event.review_status !== 'approved'" class="workspace-button workspace-button--ghost" type="button" :disabled="event.saving" @click="applyReviewStatus(event, 'approved')">
                <span>{{ event.saving ? 'Guardando...' : 'Aprobar y avisar' }}</span>
              </button>
              <button v-if="event.review_status !== 'rejected'" class="workspace-button workspace-button--ghost fee-action--danger" type="button" :disabled="event.saving" @click="applyReviewStatus(event, 'rejected')">
                <span>{{ event.saving ? 'Guardando...' : 'Rechazar' }}</span>
              </button>
              <button v-if="event.review_status !== 'pending'" class="workspace-button workspace-button--ghost" type="button" :disabled="event.saving" @click="applyReviewStatus(event, 'pending')">
                <span>{{ event.saving ? 'Guardando...' : 'Volver a pendiente' }}</span>
              </button>
              <button class="workspace-button workspace-button--primary" type="button" :disabled="event.saving" @click="saveEvent(event)">
                <span>{{ event.saving ? 'Guardando...' : 'Guardar configuracion' }}</span>
              </button>
            </div>
          </div>
        </article>
      </div>

      <p v-if="error" class="workspace-feedback workspace-feedback--error">{{ error }}</p>
      <p v-if="success" class="workspace-feedback workspace-feedback--success">{{ success }}</p>
    </article>
  </section>
</template>

<script>
import { apiService } from '../../common/api.services.js'

export default {
  name: 'PaymentFeeConfigList',

  data() {
    return {
      events: [],
      search: '',
      reviewFilter: 'all',
      loading: false,
      error: '',
      success: '',
    }
  },

  computed: {
    filteredEvents() {
      const term = this.search.trim().toLowerCase()
      const filtered = !term ? this.events : this.events.filter((event) => {
        const haystack = `${event.name || ''} ${event.slug || ''} ${event.host_name || ''}`.toLowerCase()
        return haystack.includes(term)
      })

      const statusFiltered = this.reviewFilter === 'all'
        ? filtered
        : filtered.filter((event) => event.review_status === this.reviewFilter)

      return [...statusFiltered].sort((left, right) => {
        const reviewPriority = { pending: 0, rejected: 1, approved: 2 }
        const leftPriority = reviewPriority[left.review_status] ?? 3
        const rightPriority = reviewPriority[right.review_status] ?? 3

        if (leftPriority !== rightPriority) {
          return leftPriority - rightPriority
        }

        return String(left.name || '').localeCompare(String(right.name || ''))
      })
    },

    activeOptionCount() {
      return this.filteredEvents.reduce((sum, event) => sum + this.activeSettings(event), 0)
    },

    pendingReviewCount() {
      return this.filteredEvents.filter((event) => event.review_status === 'pending').length
    },
  },

  created() {
    this.syncSearchFromRoute()
    this.loadEvents()
  },

  methods: {
    syncSearchFromRoute() {
      const search = typeof this.$route.query.reviewSearch === 'string' ? this.$route.query.reviewSearch.trim() : ''
      if (search) {
        this.search = search
      }
    },

    formatDate(value) {
      if (!value) {
        return 'Sin fecha'
      }

      return new Intl.DateTimeFormat('default', { dateStyle: 'medium' }).format(new Date(value))
    },

    activeSettings(event) {
      return (event.payment_option_settings || []).filter((setting) => setting.enabled).length
    },

    reviewLabel(value) {
      if (value === 'approved') {
        return 'Aprobado'
      }

      if (value === 'rejected') {
        return 'Rechazado'
      }

      return 'Pendiente'
    },

    reviewClass(value) {
      if (value === 'approved') {
        return 'is-active'
      }

      if (value === 'rejected') {
        return 'is-danger'
      }

      return 'is-warning'
    },

    typeLabel(value) {
      if (Number(value) === 2) {
        return 'Privado'
      }

      if (Number(value) === 3) {
        return 'No publicar aun'
      }

      return 'Publico'
    },

    pricingSourceLabel(value) {
      if (value === 'event_payment_option_config') {
        return 'config propia'
      }

      if (value === 'payment_option_default') {
        return 'default de la opcion'
      }

      return 'fallback evento'
    },

    feeModeLabel(value) {
      if (value === 'custom_fixed') {
        return 'Monto fijo'
      }

      if (value === 'custom_formula') {
        return 'Personalizado'
      }

      return 'Estandar'
    },

    feeModeCopy(setting) {
      if (setting.platform_fee_mode === 'custom_fixed') {
        return 'Esta opcion cobra un fee fijo final. No suma porcentaje ni fee por ticket.'
      }

      if (setting.platform_fee_mode === 'custom_formula') {
        return 'Esta opcion usa su propia formula de fee y no depende del fallback general del evento.'
      }

      return 'Esta opcion usa el fee estandar del evento y solo hereda el fallback general.'
    },

    normalizeEvent(event) {
      return {
        ...event,
        type: Number(event.type || 1),
        review_status: event.review_status || 'approved',
        expanded: false,
        saving: false,
        payment_option_settings: Array.isArray(event.payment_option_settings)
          ? event.payment_option_settings.map((setting) => ({
            ...setting,
            platform_fee_mode: setting.platform_fee_mode || 'standard',
          }))
          : [],
      }
    },

    loadEvents() {
      this.loading = true
      this.error = ''
      apiService('/api/admin/events/pricing/').then((data) => {
        if (data && data.err) {
          this.error = data.err
          this.events = []
          return
        }

        const items = Array.isArray(data) ? data : (data && data.results ? data.results : [])
        this.events = items.map((item) => this.normalizeEvent(item))
      }).catch(() => {
        this.error = 'No se pudo cargar la configuracion comercial.'
      }).finally(() => {
        this.loading = false
      })
    },

    applyReviewStatus(event, status) {
      event.review_status = status
      this.saveEvent(event)
    },

    saveEvent(event) {
      event.saving = true
      this.error = ''
      this.success = ''

      const payload = {
        type: event.type,
        review_status: event.review_status,
        fee_bearer: event.fee_bearer,
        coordinated_fee: event.coordinated_fee,
        fixed_fee: event.fixed_fee,
        coordinated_service: event.coordinated_service,
        payment_option_settings: event.payment_option_settings.map((setting) => ({
          payment_option_id: setting.payment_option_id,
          enabled: setting.enabled,
          is_active: setting.enabled,
          label_override: setting.label_override,
          platform_fee_mode: setting.platform_fee_mode,
          platform_fee_percent: setting.platform_fee_percent,
          platform_fee_fixed: setting.platform_fee_fixed,
          platform_fee_per_ticket: setting.platform_fee_per_ticket,
          processor_fee_percent: setting.processor_fee_percent,
          processor_fee_fixed: setting.processor_fee_fixed,
          processor_fee_extra_percent: setting.processor_fee_extra_percent,
          processor_fee_extra_tax_percent: setting.processor_fee_extra_tax_percent,
          currency: setting.currency,
        })),
      }

      apiService(`/api/admin/events/${event.id}/pricing/`, 'PATCH', payload).then((data) => {
        if (!data || data.err) {
          this.error = (data && data.err) || `No se pudo guardar la configuracion de ${event.name}.`
          return
        }

        const index = this.events.findIndex((item) => item.id === event.id)
        if (index !== -1) {
          const updated = this.normalizeEvent(data)
          updated.expanded = true
          this.events.splice(index, 1, updated)
        }
        this.success = data.review_status === 'approved'
          ? `Configuracion guardada y evento aprobado para ${data.name}.`
          : data.review_status === 'rejected'
            ? `Evento rechazado para ${data.name}.`
            : `Evento marcado como pendiente para ${data.name}.`
      }).catch(() => {
        this.error = `No se pudo guardar la configuracion de ${event.name}.`
      }).finally(() => {
        event.saving = false
      })
    },
  },

  watch: {
    '$route.query.reviewSearch'() {
      this.syncSearchFromRoute()
    },
  },
}
</script>

<style scoped>
.fee-toolbar__filter {
  min-width: 220px;
}

.fee-config-stack {
  display: grid;
  gap: 18px;
}

.fee-event-card {
  padding: 20px;
  border-radius: 24px;
  border: 1px solid rgba(223, 214, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.fee-event-card__top,
.fee-event-card__actions,
.fee-option-card__head,
.fee-option-card__effective {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
}

.fee-event-card__top h3 {
  margin: 6px 0;
  color: var(--text-main);
}

.fee-event-card__top p,
.fee-option-card__head small,
.fee-option-card__effective {
  color: var(--text-soft);
}

.fee-event-card__review-note {
  margin: 0;
  color: var(--text-soft);
  line-height: 1.6;
}

.fee-event-card__review-note strong {
  color: var(--text-main);
}

.fee-option-card__note {
  margin: 0;
  color: var(--text-soft);
  line-height: 1.55;
}

.fee-event-card__body {
  margin-top: 18px;
  display: grid;
  gap: 18px;
}

.fee-defaults-grid,
.fee-option-card__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 14px;
}

.fee-option-grid {
  display: grid;
  gap: 14px;
}

.fee-option-card {
  padding: 16px;
  border-radius: 20px;
  border: 1px solid rgba(223, 214, 255, 0.08);
  background: rgba(0, 0, 0, 0.16);
  display: grid;
  gap: 14px;
}

.fee-option-card__toggle {
  display: inline-flex;
  gap: 10px;
  align-items: center;
  color: var(--text-main);
  font-weight: 700;
}

.fee-option-card__effective {
  flex-wrap: wrap;
  font-size: 0.85rem;
}

.fee-action--danger {
  border-color: rgba(255, 154, 154, 0.26);
  color: #ffd7d7;
}

.fee-action--danger:hover {
  background: rgba(168, 76, 76, 0.14);
}

:deep(.workspace-status-pill.is-danger) {
  background: rgba(168, 76, 76, 0.18);
  color: #ffd7d7;
  border-color: rgba(255, 154, 154, 0.24);
}

@media (max-width: 720px) {
  .fee-toolbar__filter {
    min-width: 0;
    width: 100%;
  }

  .fee-event-card__top,
  .fee-event-card__actions,
  .fee-option-card__head,
  .fee-option-card__effective {
    display: grid;
  }
}
</style>
